import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from "react";

type ButtonVariant = "primary" | "secondary" | "ghost" | "danger";

type ButtonSize = "sm" | "md";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  size?: ButtonSize;
  variant?: ButtonVariant;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  function Button(
    {
      children,
      className,
      size = "md",
      type = "button",
      variant = "primary",
      ...props
    },
    ref,
  ) {
    const classes = ["marker-button", `marker-button--${variant}`];
    classes.push(`marker-button--${size}`);
    if (className) {
      classes.push(className);
    }

    return (
      <button className={classes.join(" ")} ref={ref} type={type} {...props}>
        {children}
      </button>
    );
  },
);
